import React from 'react'
import { Box, IconButton } from '@mui/material'
import { useTheme } from '@mui/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowIcon from '@mui/icons-material/ArrowBackIos'
import { useVenueContext } from 'providers/VenueProvider'

const WelcomeHeader = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { currentVenueData, isDefaultVenue } = useVenueContext()

  return (
    <Box sx={{ [theme.breakpoints.up('sm')]: { minHeight: '20vh' }, minHeight: '15vh' }}>
      <Box sx={{ display: 'grid', position: 'relative', width: 1 }}>
        <IconButton sx={{ position: 'absolute', top: 50, display: !pathname.includes('home') && 'none' }} onClick={() => { navigate('/game-mode') }}><ArrowIcon /></IconButton>
        <Box component="img" src="/wineSmash.svg" alt="wine-smash" sx={{ p: 2, width: 150, display: 'flex', mx: 'auto', mb: '2rem' }} />
        { !isDefaultVenue && currentVenueData?.logo &&
          <>
            <p style={{ margin: '0', textAlign: 'center' }}>In partnership with</p>
            <Box
              component="img"
              src={currentVenueData.logo}
              alt={currentVenueData.name}
              sx={{ p: 2, width: 150, display: 'flex', mx: 'auto', mb: '2rem' }}
            />
          </>
        }
      </Box>
      <Box sx={{ fontSize: '1.5rem', textAlign: 'center' }}>
        <h3 style={{ padding: '0', margin: '0' }}>Choice of Games</h3>
      </Box>
    </Box>
  )
}

export default WelcomeHeader
